"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function usdt(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.473 12.5014V12.4999C13.3905 12.5059 12.9652 12.5314 12.0165 12.5314C11.259 12.5314 10.7257 12.5089 10.5382 12.4999V12.5021C7.62222 12.3739 5.44572 11.8661 5.44572 11.2586C5.44572 10.6519 7.62222 10.1441 10.5382 10.0136V11.9966C10.7287 12.0101 11.2747 12.0424 12.0292 12.0424C12.9345 12.0424 13.3882 12.0049 13.473 11.9974V10.0151C16.383 10.1449 18.5542 10.6526 18.5542 11.2586C18.5542 11.8661 16.383 12.3724 13.473 12.5014ZM13.473 9.80887V8.03437H17.5335V5.32837H6.47772V8.03437H10.5382V9.80812C7.23822 9.95962 4.75647 10.6136 4.75647 11.3966C4.75647 12.1796 7.23822 12.8329 10.5382 12.9851V18.6716H13.473V12.9836C16.7677 12.8321 19.2435 12.1789 19.2435 11.3966C19.2435 10.6144 16.7677 9.96112 13.473 9.80887Z", fill: color }));
}
exports["default"] = usdt;
//# sourceMappingURL=usdt.js.map